module.exports = __webpack_public_path__ + "img/emoji_023.249d1341.png";